/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_GInputs */

const en_tut_fokus_g = /** @type {(inputs: Tut_Fokus_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The office is not only for talking. Shared focus agrees on quiet time, and status objects put the state of the work on the wall of a room.`)
};

const id_tut_fokus_g = /** @type {(inputs: Tut_Fokus_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kantor bukan hanya untuk mengobrol. Fokus bersama menyepakati waktu tenang, dan objek status menampilkan kondisi pekerjaan di dinding ruang.`)
};

/**
* | output |
* | --- |
* | "The office is not only for talking. Shared focus agrees on quiet time, and status objects put the state of the work on the wall of a room." |
*
* @param {Tut_Fokus_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_g = /** @type {((inputs?: Tut_Fokus_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_g(inputs)
	return en_tut_fokus_g(inputs)
});